<template>
  <div>
    <v-row>
      <v-col cols="6" xs="12" class="pb-0">
        <!-- Tipo de buceo -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon icon="cp-diver-2" :fill="iconFill" :height="iconHeight" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Tipo de buceo</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="event.samplingProtocol">{{
                event.samplingProtocol || "-"
              }}</span>
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Duración -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-duration"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Duración</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="event.samplingEffort"
                >{{ event.samplingEffort || "-" }} minutos</span
              >
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Profundidad -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-depth"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Profundidad</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="event.verbatimDepth || event.maximumDepthInMeters"
                >{{ event.verbatimDepth || "--" }} m •
                {{ event.maximumDepthInMeters || "--" }} m</span
              >
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="6" xs="12" class="pb-0">
        <!-- Corriente -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-current"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Corriente</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="event.current">{{ event.current }}</span>
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Visibilidad -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-visibility"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Visibilidad</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="(event.dynamicProperties || {}).visibilityMeters"
                >{{
                  (event.dynamicProperties || {}).visibilityMeters
                }}
                metros</span
              >
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Temperatura -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-temperature"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Temperatura</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span
                v-if="
                  event.measurementValue &&
                    (event.measurementValue.temperatureMin ||
                      event.measurementValue.temperatureMax)
                "
              >
                {{ (event.measurementValue || {}).temperatureMin || "--" }}º C •
                {{ (event.measurementValue || {}).temperatureMax || "--" }}º C
              </span>
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" class="pt-0">
        <!-- Hábitat -->
        <v-list-item>
          <v-list-item-icon>
            <SvgIcon
              icon="cp-event-habitat"
              :fill="iconFill"
              :height="iconHeight"
            />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle
              class="body-1 secondary--text font-weight-bold"
              >Hábitat</v-list-item-subtitle
            >
            <v-list-item-title
              class="body-1 font-weight-medium blue-grey--text"
            >
              <span v-if="event.habitat">{{ event.habitat.join(", ") }}</span>
              <span v-else>Sin especificar</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SvgIcon from "../SvgIcon";

export default {
  components: { SvgIcon },
  props: ["event"],
  data: () => ({
    iconFill: "#004480",
    iconHeight: "35px"
  })
};
</script>

<style></style>
